import SectionHead from './SectionHead'

const INCLUDED = [
  'Solo sessions, as many as you need',
  'Team sessions for up to 12 people',
  'Teams with a shared dashboard',
  'Downloadable deliverables, including your prompt pack',
  'Your session summary, emailed to you',
]

export default function WhatsIncludedSection({
  onStart,
  onSolo,
}: {
  onStart: () => void
  onSolo: () => void
}) {
  return (
    <section className="bg-stone py-14 md:py-16">
      <div className="mktg-container">
        <SectionHead
          mark="SECT. 07"
          title="Included in every session"
          note="Nothing to unlock, nothing held back, no card to enter."
        />

        <div className="card card-shadow max-w-2xl p-6 md:p-8">
          <ul className="mb-7">
            {INCLUDED.map((item) => (
              <li
                key={item}
                className="flex items-start gap-3 py-2.5 border-b border-navy/15 last:border-0 text-navy/80"
              >
                <span className="waypoint mt-1.5" aria-hidden="true" />
                {item}
              </li>
            ))}
          </ul>
          <div className="flex flex-col sm:flex-row gap-3">
            <button onClick={onSolo} className="btn btn-amber flex-1">
              Start a solo session
            </button>
            <button onClick={onStart} className="btn btn-navy flex-1">
              Run it with your team
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}
